const tours = {
  OnBoardTour: 'OnBoardTour',
}


export default tours
